import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const AdminRoute = ({ children }) => {
  const { token, user, authReady } = useAuth();
  const lsToken = localStorage.getItem('access_token');

  if (!authReady) return null;

  if (!(token || lsToken)) return <Navigate to="/" replace />;

  // Wait for /me hydration (user could be null momentarily right after login)
  if (!user) return null;

  if (user?.role !== 'admin') return <Navigate to="/dashboard" replace />;
  return children;
};

export default AdminRoute;
